import {
  Filterable
} from "./chunk.TOSSI7AO.js";
import {
  Linkable
} from "./chunk.ABOYTYJO.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-news-list-item/jb-news-list-item.scss?inline
var jb_news_list_item_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
section {
  position: relative;
}
section::before, section::after {
  bottom: 0;
  content: "";
  height: 1px;
  position: absolute;
  width: 100%;
  z-index: 101;
}
section::before {
  background: rgba(20, 30, 85, 0.2);
}
section::after {
  background: #141e55;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.8s ease-in-out;
}
section:hover::after {
  transform: scaleX(1);
  transition-duration: 0.5s;
}

/* stylelint-disable */
/* stylelint-enable */
a {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

a {
  color: rgba(var(--rgb-primary, 20, 30, 85), var(--text-opacity, var(--theme-opacity-80, 0.8)));
  font-size: 1rem;
  line-height: 1.625rem;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
}

section {
  --text-opacity: 1;
  padding-bottom: 12px;
}

a {
  display: block;
  margin-bottom: 16px;
  text-decoration: none;
}
a:not([href]) {
  color: rgba(0, 0, 0, 0.2);
}

.meta {
  display: flex;
}

jb-date {
  margin-right: 20px;
}

jb-language-item {
  --text-opacity: 0.4;
  padding: 0 15px;
  position: relative;
}
jb-language-item:first-of-type {
  padding-left: 0;
}
jb-language-item::after {
  background-color: rgb(var(--rgb-primary, 20, 30, 85));
  border-radius: 100%;
  content: "";
  height: 3px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
}
jb-language-item:last-of-type::after {
  content: none;
}`;

// src/components/jb-news-list-item/jb-news-list-item.ts
var JbNewsListItem = class extends Filterable(Linkable(h)) {
  render() {
    return ke`
      <section>
        ${this.link ? ke`<a data-linkable>${this.newsTitle}</a>` : ke`<a>${this.newsTitle}</a>`}
        <div class="meta">
          <jb-date date=${this.date}></jb-date>
          ${this.languages ? ke`
                <ul>
                  ${this.languages.map(
      (language) => ke`<jb-language-item
                        .text=${language.text}
                        .link=${language.link}
                      ></jb-language-item>`
    )}
                </ul>
              ` : D}
        </div>
      </section>
    `;
  }
};
JbNewsListItem.styles = r(jb_news_list_item_default);
__decorateClass([
  n()
], JbNewsListItem.prototype, "date", 2);
__decorateClass([
  n({ type: Array })
], JbNewsListItem.prototype, "languages", 2);
__decorateClass([
  n()
], JbNewsListItem.prototype, "newsTitle", 2);
JbNewsListItem = __decorateClass([
  customElement("jb-news-list-item")
], JbNewsListItem);

export {
  JbNewsListItem
};
